const slackBelow = ({ scrollHeight, scrollTop, clientHeight }) => scrollHeight - scrollTop - clientHeight;

export const collapseDeficit = (removedHeight, scroller) => Math.max(0, Math.ceil(removedHeight - slackBelow(scroller)) + 1);

export const remainingGuard = (guard, scroller) => Math.max(0, guard - slackBelow(scroller));
